export const boardBoardCallTour = {
  key: "boardBoardCall",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-call-start"]',
      content: t("Tour_BoardCall_Start"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-call-audio"]',
      content: t("Tour_BoardCall_Audio"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-call-video"]',
      content: t("Tour_BoardCall_Video"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-call-sharescreen"]',
      content: t("Tour_BoardCall_ShareScreen"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-call-end"]',
      content: t("Tour_BoardCall_End"),
      placement: "bottom",
    },
  ],
};
